import { useState } from 'react'
import { hasConsent, grantConsent } from '../services/mixpanel.js'

const CookieConsentBanner = () => {
  const [accepted, setAccepted] = useState(() => hasConsent())

  if (accepted) return null

  const handleAccept = () => {
    grantConsent()
    setAccepted(true)
  }

  return (
    <div className="cookie-consent-overlay">
      <div
        className="cookie-consent-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-consent-title"
      >
        <h2 id="cookie-consent-title">We use cookies</h2>
        <p>
          To use Keyzee, you must accept cookies. We use cookies to help improve your
          experience. Read our <a href="/cookies/">Cookie Policy</a>.
        </p>
        <button
          type="button"
          className="primary-button cookie-consent-modal__accept"
          onClick={handleAccept}
        >
          Accept
        </button>
      </div>
    </div>
  )
}

export default CookieConsentBanner
